import type { NleClipInfoMap } from '@mimir/client-common/fileSync/premiereTypes';
import { evalRawScript, getFresh } from './cep';
import type { AdobePanelContext } from '@mimir/common/context/applicationContext';
import type { Logger } from '@mimir/common/types/logger';
import { invariant } from '@mimir/common/util/invariant';

const JSON2_PATH = '/assets/premiere/json2.min.js';
export const PPRO_BUNDLE_PATH = '/assets/adobe/ppro.jsx';
let bundleLoaded = false;

// Loads ExtendScript bundles for ae/ps/audition/ppro.
// In extendscript/scripts/bundleCommon.js, ae/ps/audition are exposed as $.global.MimirPanelNext,
// while ppro is exposed as $.global.ppro (assigned explicitly after Browserify bundling).
// json2 polyfill is loaded first since the bundle may use JSON.stringify/JSON.parse.
async function loadAppBundle(bundlePath: string): Promise<void> {
  if (bundleLoaded) {
    return;
  }
  const [json2, bundle] = await Promise.all([
    getFresh(JSON2_PATH),
    getFresh(bundlePath),
  ]);
  await evalRawScript(json2);
  const result = await evalRawScript(`${bundle};${bundlePath.includes('ppro.jsx') ? '$.global.ppro.initialize();' : ''}"OK"`);
  invariant(result === 'OK', `Failed to load ${bundlePath}`);
  bundleLoaded = true;
}

export const initializePremiere = async (
  applicationContext: AdobePanelContext,
  logger: Logger,
  premiereClipInfos: NleClipInfoMap,
) => {
  // ppro.jsx is loaded lazily by cepNleOps.ts on the first NLE operation.
  // ppro.initialize() (metadata schemas + app.bind events) is called there.
  // registerNleEventHandlers(applicationContext, logger, premiereClipInfos);

  // handle panel close event.
  // window.addEventListener('beforeunload', unsubscribeNleEventHandlers);

  // Start loop processing open projects in the background.
  // Will be killed when the panel is closed, since the panel is a web app.
  // startCheckOpenProjectsLoop(
  //   applicationContext,
  //   logger,
  //   premiereClipInfos,
  // ).catch(err => console.error(err));
};

export const initializeAe = async () => loadAppBundle('/assets/adobe/ae.jsx');
export const initializePs = async () => loadAppBundle('/assets/adobe/ps.jsx');
export const initializeAudition = async () => loadAppBundle('/assets/adobe/audition.jsx');
export const initializePpro = async () => loadAppBundle(PPRO_BUNDLE_PATH);
